import { render, staticRenderFns } from "./ChannelItemMediaPlayer.vue?vue&type=template&id=1e477626"
import script from "./ChannelItemMediaPlayer.vue?vue&type=script&lang=js"
export * from "./ChannelItemMediaPlayer.vue?vue&type=script&lang=js"
import style0 from "./ChannelItemMediaPlayer.vue?vue&type=style&index=0&id=1e477626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports